import Image from '../elements/image/image';
import React from 'react';

import logoImage from '../../../public/bb_logo.svg';
import styles from './bb-logo.module.scss';

const BBLogo: React.FC = () => {
  return (
    <div className={styles.container}>
      <Image
        src={logoImage}
        role="presentation"
        alt=""
        layout="fill"
        priority={true}
      />
    </div>
  );
};

export default BBLogo;
